<template>
  <div class="main">
    <base-card v-for="beverage in beverages" :key="beverage.name">
      <v-card-title class="flex text-left">{{ beverage.name }}</v-card-title>
      <v-card-actions class="flex text-left">
        {{ beverage.bottleS }} <br />
        {{ beverage.bottleL }}
        <v-spacer></v-spacer>
        {{ beverage.priceS }} <br />
        {{ beverage.priceL }}
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      beverages: [
        {
          name: "Coca Cola",
          bottleS: "0.33l",
          bottleL: "0.45l",
          priceS: "60 den.",
          priceL: "70 den.",
        },
        {
          name: "Coca Cola Zero",
          bottleS: "0.33l",
          bottleL: "0.45l",
          priceS: "60 den.",
          priceL: "70 den.",
        },
        {
          name: "Fanta",
          bottleS: "0.33l",
          bottleL: "0.45l",
          priceS: "60 den.",
          priceL: "70 den.",
        },
        {
          name: "Sprite",
          bottleS: "0.33l",
          bottleL: "0.45l",
          priceS: "60 den.",
          priceL: "70 den.",
        },
        {
          name: "Schweppes Bitter Lemon",
          bottleS: "0.33l",
          bottleL: "0.5l",
          priceS: "60 den.",
          priceL: "70 den.",
        },
        {
          name: "Rosa - Ujë",
          bottleS: "",
          bottleL: "0.5l",
          priceS: "",
          priceL: "50 den.",
        },
        {
          name: "Çaj i ftohtë pjeshke",
          bottleS: "0.3l",
          bottleL: "0.33l",
          priceS: "40 den.",
          priceL: "50 den.",
        },
        {
          name: "Limonadë",
          bottleS: "0.3l",
          bottleL: "0.33l",
          priceS: "40 den.",
          priceL: "50 den.",
        },
        {
          name: "Boronice",
          bottleS: "0.3l",
          bottleL: "0.33l",
          priceS: "40 den.",
          priceL: "50 den.",
        },
        {
          name: "Mjedër",
          bottleS: "0.3l",
          bottleL: "0.33l",
          priceS: "40 den.",
          priceL: "50 den.",
        },
        {
          name: "Kafeja turke",
          bottleS: "",
          bottleL: "",
          priceS: "60 den.",
          priceL: "",
        },
        {
          name: "3 në 1",
          bottleS: "",
          bottleL: "",
          priceS: "60 den.",
          priceL: "",
        },
        {
          name: "Nescafe",
          bottleS: "",
          bottleL: "",
          priceS: "",
          priceL: "80 den.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 180vh;
  background: transparent;
}
</style>
